<template>
  <div>
    <div class="card">
      <header class="card-header pointer" @click="toggleOpen(category)">
        <p class="card-header-title">
          {{ hoofdletter(category).replaceAll("_", " ") }}
        </p>
      </header>
      <span v-if="open === category">
        <div class="card-content">
          <span v-if="showVariables">
            <strong>Usable variables:</strong> <br />
            <div class="columns">
              <div class="column">
                Order nummer<br />
                Klant voornaam<br />
                Klant achternaam<br />
                Klant bedrijfsnaam<br />
                Klant email <br />
                Klant telefoonnummer <br />
                Klant postcode <br />
                Klant huisnummer <br />
                Klant huisnummer extensie <br />
                Klant straat <br />
                Klant plaats <br />
                Order bezorg optie <br />
                Order totaal prijs <br />
                Order totaal korting<br />
                Order aantaal producten<br />
                <br />
                Begintijdstip van tijdvak bezorgen <br />
                Eindetijdstip van tijdvak bezorgen <br />
                Begintijdstip van eten op HDB<br />
                <br />
                Donatie bedrag <br />
                <br />
                Contact email link <br />
                Contact telefoonnummer link <br />
                Contact formulier link<br />
              </div>
              <div class="column">
                @@@@order_nummer@@@@ <br />
                @@@@klant_voornaam@@@@ <br />
                @@@@klant_achternaam@@@@ <br />
                @@@@klant_bedrijfsnaam@@@@ <br />
                @@@@klant_email@@@@ <br />
                @@@@klant_telefoonnummer@@@@ <br />
                @@@@klant_postcode@@@@ <br />
                @@@@klant_huisnummer@@@@ <br />
                @@@@klant_huisnummer_extensie@@@@ <br />
                @@@@klant_straat@@@@ <br />
                @@@@klant_plaats@@@@ <br />
                @@@@bezorg_optie@@@@ <br />
                @@@@totaal_prijs@@@@ <br />
                @@@@totaal_korting@@@@ <br />
                @@@@producten@@@@ <br />
                <br />
                @@@@soep_bezorgtijden_begin@@@@ <br />
                @@@@soep_bezorgtijden_eind@@@@ <br />
                @@@@soep_pickup_begin@@@@ <br />
                <br />
                @@@@donatie_bedrag@@@@ <br />
                <br />
                @@@@dagelijkse_soep_telefoonnummer@@@@ <br />
                @@@@dagelijkse_soep_email@@@@ <br />
                @@@@contact_formulier@@@@
              </div>
            </div>
            <br />
          </span>
          <div class="content">
            <span v-if="computedSettings">
              <span v-for="variable in computedSettings.length" :key="variable">
                <b-switch
                  class="customInput"
                  v-if="computedSettings[variable - 1].type === 'switch'"
                  v-model="form[computedSettings[variable - 1].key]"
                >
                  {{ computedSettings[variable - 1].name }}
                </b-switch>

                <br v-if="computedSettings[variable - 1].type === 'switch'" />

                <formEditor
                  :value="form[computedSettings[variable - 1].key]"
                  class="customInput"
                  :model="form"
                  :title="computedSettings[variable - 1].name"
                  :modelKey="computedSettings[variable - 1].key"
                  v-if="computedSettings[variable - 1].type === 'editor'"
                />

                <formInput
                  v-if="computedSettings[variable - 1].type === 'input'"
                  class="customInput"
                  :title="computedSettings[variable - 1].name"
                  :model="form"
                  :modelKey="computedSettings[variable - 1].key"
                  label="on-border"
                  :placeholder="computedSettings[variable - 1].name"
                />

                <formCheckbox
                  v-if="computedSettings[variable - 1].type === 'checkbox'"
                  class="customInput"
                  :title="computedSettings[variable - 1].name"
                  :model="form"
                  :modelKey="computedSettings[variable - 1].key"
                  :labelHidden="true"
                  :placeholder="computedSettings[variable - 1].name"
                />

                <formTimePicker
                  v-if="computedSettings[variable - 1].type === 'timepicker'"
                  class="customInput"
                  :title="computedSettings[variable - 1].name"
                  :model="form"
                  :modelKey="computedSettings[variable - 1].key"
                  :labelHidden="true"
                  :placeholder="computedSettings[variable - 1].name"
                />

                <FormSelect
                  v-if="computedSettings[variable - 1].type === 'select'"
                  class="customInput"
                  :selectOptions="computedSettings[variable - 1].options"
                  :title="computedSettings[variable - 1].name"
                  :model="form"
                  label="on-border"
                  :modelKey="computedSettings[variable - 1].key"
                  :placeholder="computedSettings[variable - 1].name"
                />

                <formSinglePictureUpload
                  v-if="computedSettings[variable - 1].type === 'file_upload'"
                  class="customInput"
                  :title="computedSettings[variable - 1].name"
                  :model="form"
                  :category="category"
                  label="on-border"
                  :modelKey="computedSettings[variable - 1].key"
                  :placeholder="computedSettings[variable - 1].name"
                />

                <br />
              </span>
            </span>
          </div>
        </div>
        <footer class="card-footer">
          <span class="card-footer-item">
            <button
              v-if="category !== 'pictures'"
              :class="{
                'is-loading': ajaxloading.save_variables,
              }"
              class="button is-primary is-rounded"
              @click="saveVariables()"
            >
              Opslaan
            </button></span
          >
        </footer>
      </span>
    </div>
  </div>
</template>

<script>
import FormSelect from "../form/formSelect.vue";
export default {
  components: { FormSelect },
  props: {
    category: {
      required: true,
      type: String,
    },
    open: {
      required: true,
      type: String,
    },
    card_settings: {
      required: true,
      type: Array,
    },
    form: {
      required: true,
      type: Object,
    },
    showVariables: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    computedSettings() {
      if (this.card_settings.length) {
        return this.card_settings.filter((a) => a.category === this.category);
      } else {
        return [];
      }
    },
  },
  methods: {
    saveVariables() {
      this.$emit("save", this.category);
    },
    toggleOpen() {
      this.$emit("toggle", this.category);
    },
  },
  mounted() {},
};
</script>
